import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReversePipe } from './reverse.pipe';
import { AgePipe } from './age.pipe';
import { DateIntervalPipe } from './date-interval.pipe';
import { SafeHtml } from './safe-html.pipe';
import { ChartOfAccountPipe } from './chart-of-account.pipe';
import { IncomesVsExpensesPipe } from './incomes-vs-expenses.pipe';
import { MonthPipe } from './month.pipe';

const all = [AgePipe, ReversePipe, DateIntervalPipe, SafeHtml, ChartOfAccountPipe, IncomesVsExpensesPipe, MonthPipe];
@NgModule({
  imports: [CommonModule],
  declarations: [...all],
  exports: [...all]
})
export class PipesModule {}
